import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import CurrencyInput from 'react-number-format';
import { translate as t } from 'admin-on-rest';
import { get } from 'lodash';

import { formatViewPrice, formatDbPrice } from '../../utils/NumberUtils';

const formatPrecision = (props, precision) => typeof precision === 'string' ? get(props.record, precision) : precision === 0 ? precision : precision || 2;


export class TextInput extends Component {
  constructor(props) {
    super(props);
    const { input: { value }, precision } = this.props;
    const v = `${value}`;
    const prec = formatPrecision(this.props, precision);

    this.state = {
      value: value ? formatViewPrice(`${v.slice(0, -2)}.${v.slice(-2)}`, prec) : '',
    };
  }

  handleChange = ({ value }, prec) => {
    this.setState({ value });
    this.props.input.onChange(formatDbPrice(value, prec));
  };

  render() {
    const {
      input,
      currencyCode,
      precision,
      label,
      translate,
      source,
      resource,
    } = this.props;
    const prec = formatPrecision(this.props, precision);
    const cCode = get(this.props.record, currencyCode);
    return (
      <CurrencyInput
        floatingLabelText={resource ? translate(`resources.${resource}.fields.${label || source}`) : translate(label)}
        value={this.state.value}
        suffix={currencyCode ? ` ${cCode || currencyCode}` : ''}
        customInput={TextField}
        onValueChange={(val) => this.handleChange(val, prec)}
        {...this.props}
        onChange={() => {}}
        onBlur={(e) => {
          this.setState({ value: formatViewPrice(e.target.value, prec) });
          input.onChange(formatDbPrice(e.target.value, prec));
        }}
      />
    );
  }
}

TextInput.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  onChange: PropTypes.func,
};

TextInput.defaultProps = {
  addField: true, // eslint-disable-line
  onChange: () => {},
};

export default t(TextInput);
